// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"outletSubtitle_subtitle__n0yS6","locationIconWrapper":"outletSubtitle_locationIconWrapper__d5pZj"};